import { IPayload } from "Model/IPayload";
import ApiHelperService from "Service/ApiHelperService";

import { API_URL, apiMethod, apiType } from "utils";


const LogError = (error: Error, info: any) => {
  let errorLogDetails = {
    ErrorMessage: error.message,
    ErrorDescription: info.componentStack,
    ErrorType: error.name,
    IsReact: true,
    ApplicationType: 'UI-Leader',
  }
    let PayloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.Identity,
        endpoint: `errorlog/save`,
        payload: errorLogDetails
    }
    const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL
    ApiHelperService.post(`${webAppBaseUrl}${API_URL.PostWebApp}`, PayloadData)

}
export default LogError;